var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardRightFootprint(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1345 8.17824L10.3411 5.37365C10.455 5.27415 10.6266 5.2841 10.7263 5.39605C13.7984 8.85088 14.9817 8.28787 16.853 10.6802C18.1727 12.3677 18.1331 14.4138 16.7446 15.6283C15.1506 17.0226 11.7395 16.3659 9.00888 12.2622C8.22432 11.083 7.61836 9.83574 7.06067 8.49236C7.0152 8.38323 7.04491 8.25651 7.13434 8.17844L7.1345 8.17824Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0073 4.43281C10.0775 4.54691 10.0544 4.69568 9.95304 4.78453L6.71582 7.61613C6.61442 7.70499 6.46393 7.70776 6.36047 7.62251C6.08177 7.3923 5.50751 6.88441 4.80629 6.07935C3.59296 4.68628 3.78628 3.38251 4.97489 2.34308C6.1633 1.30348 7.47836 1.28783 8.69169 2.6809C9.39272 3.48579 9.81727 4.12459 10.0074 4.43262L10.0073 4.43281Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardRightFootprint);
export default __webpack_public_path__ + "static/media/dashboardRightFootprint.9da02947f41d88059c747c556764101c.svg";
export { ForwardRef as ReactComponent };